"use client";

import { useTranslations } from "next-intl";
import { threeSixtyAnimation } from "../../../../public/images/three-sixty";
import StepContainer from "./StepContainer";

const StepFour = () => {
  const t = useTranslations("threeSixtySteps.steps");

  return (
    <div className="bg-secondary">
      <div className="gs--page-column py-16">
        <StepContainer
          title={t("step4.title")}
          text={t("step4.text")}
          src={threeSixtyAnimation}
          alt={"GIF Animation eines 360 Grad Icons"}
          imageLeft
          unoptimized={true}
          width={300}
        />
      </div>
    </div>
  );
};

export default StepFour;
